import { createBrowserRouter } from "react-router";
import { Layout } from "./Layout";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { RelayersPage } from "./pages/RelayersPage";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <Layout />,
    children: [
      { index: true, element: <RelayersPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
